import type { ConversationChannel } from "../types/ConversationChannel";
import { QueueBanner } from "./QueueBanner";
import { Thinking } from "./common/Thinking";

interface ConversationViewLoadingStatesProps {
  channel: ConversationChannel | null;
  isBotProcessing: boolean;
  isWaitingInQueue: boolean;
  queuePosition: number | null;
}

export const ConversationViewLoadingStates = ({
  channel,
  isBotProcessing,
  isWaitingInQueue,
  queuePosition,
}: ConversationViewLoadingStatesProps) => {
  const isShowingThinking = isBotProcessing;
  const isShowingQueue = channel === "live_chat" && isWaitingInQueue;
  const shouldRenderLoadingSection = isShowingThinking || isShowingQueue;

  if (!shouldRenderLoadingSection) {
    return null;
  }

  return (
    <div className="mt-4 flex flex-col">
      {isShowingThinking && <Thinking />}
      {isShowingQueue && queuePosition !== null && (
        <QueueBanner queuePosition={queuePosition} />
      )}
    </div>
  );
};
